import {NgModule} from '@angular/core';
import {RouterModule, Routes} from "@angular/router";
import {LoginComponent} from "../shared/login/login.component";
import {PagesComponent} from "../pages/pages.component";
import {AuthenticationGuard} from "./guards/authentication/authentication.guard";

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  {
    path: 'pages',
    component: PagesComponent,
    children:
      [
        {
          path: 'dashboard',
          loadChildren:  () => import('../pages/inicio/inicio.module').then(m => m.InicioModule),
        },
        {
          path: 'create',
          loadChildren:  () => import('../pages/create/create.module').then(m => m.CreateModule),
        },
        {
          path: 'reduction',
          loadChildren:  () => import('../pages/reduction/reduction.module').then(m => m.ReductionModule),
        },
        {
          path: 'status',
          loadChildren:  () => import('../pages/estado/estado.module').then(m => m.EstadoModule),
        },
        {
          path: 'validation',
          loadChildren: () => import('../pages/validation/validation.module').then(m => m.ValidationModule)
        },
        {
          path: 'forules',
          loadChildren: () => import('../pages/forules/forules.module').then(m => m.ForulesModule)
        }
      ],
    canActivateChild: [AuthenticationGuard]
  }
]
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
